import React from 'react';

import ReactMarkdown from "react-markdown"
import StrapiImage from "../components/StrapiImage.js"
import SectionGrid from "./sectiongrid.js"
import BackgroundImage from 'gatsby-background-image'
import AccordianSection from './accordiansection.js'
import ColumnSection from './columnsection.js'
import {returnImage} from '../actions/utils.js'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import Graph from "../components/graph.js"
import Video from "./WistiaEmbed.js"
import "../css/article_image.css"




const ArticleContent = props => {
  if(props.data.Content !== null){


    if(props.data.Type === "pullout"){
      return(<div className="pullout" style={{backgroundColor:props.Color.HeaderBackgroundColour,color:props.Color.HeaderTitleColour}}> <ReactMarkdown escapeHtml={false} source={props.data.Content} linkTarget='_blank'/></div>)
    }else if(props.data.Type === "emphasis"){
      return(<div className="emphasis"> <ReactMarkdown escapeHtml={false} source={props.data.Content} linkTarget='_blank'/></div>)
    }else if(props.data.Type === "quote"){
      return(
        <blockquote className="quote">
        <div className="aecom-quote-mark-top" aria-hidden="true" >
        <svg style={{ fill: props.data.BackgroundColour, stroke:props.data.BackgroundColour }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 174"><path d="M74.1 13.1C33.5 37.3 4 72.1 4 115.7c0 27.1 14.8 51.9 45.4 51.9 24.7 0 41.3-15.9 41.3-37.7 0-16.1-9.5-30.6-24.1-37.1l-17.7 17.1c-6.1-3.4-9.6-10.1-8.9-17.1 0-25.3 22.4-46 46.5-61.3L74.1 13.1zm106.4 0c-40.7 24.1-70.1 58.9-70.1 102.5 0 27.1 14.8 51.9 45.4 51.9 24.7 0 41.3-15.9 41.3-37.7 0-16.1-9.5-30.6-24.1-37.1l-17.7 17.1c-6.1-3.4-9.5-10.1-8.8-17.1 0-25.3 22.4-46 46.5-61.3l-12.5-18.3z"/></svg>
        </div>
          <div className=""><ReactMarkdown source={props.data.Content} escapeHtml={false} linkTarget='_blank'/></div>
          <div className="aecom-quote-mark-bottom" aria-hidden="true">
        <svg style={{ fill: props.data.BackgroundColour, stroke:props.data.BackgroundColour }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 174"><path d="M127 167.6c40.6-24.2 70.1-59 70.1-102.6 0-27.1-14.8-51.9-45.4-51.9-24.7 0-41.3 15.9-41.3 37.7 0 16.1 9.5 30.6 24.1 37.1l17.7-17.1c6.1 3.4 9.6 10.1 8.9 17.1 0 25.3-22.4 46-46.5 61.3l12.4 18.4zm-106.4 0c40.7-24.1 70.1-58.9 70.1-102.5 0-27.1-14.8-51.9-45.4-51.9C20.6 13.2 4 29.1 4 50.9 4 67 13.5 81.5 28.1 88l17.7-17.1c6.1 3.4 9.5 10.1 8.8 17.1 0 25.3-22.4 46-46.5 61.3l12.5 18.3z"/></svg>
          </div>
        </blockquote>
      )
    }
    else{
    return(<ReactMarkdown source={props.data.Content} escapeHtml={false} linkTarget='_blank'/>)
    }



  }else if(props.data.Image !== null){
      return(
          <div className={`${props.data.size}_image ${props.data.position}_image ${props.data.inline==="true" ? "inlineimage":""}` }>
            <figure>
            <StrapiImage imageInfo={props.data.Image}/>
            <figcaption>{props.data.caption}</figcaption>
            </figure>
          </div>
          )
  }else if(props.data.graph !== null){

        return(<Graph data={props.data.graph}/>)

  }else if(props.data.wistia_id !== null){
        return( <Video hashedId={props.data.wistia_id} playerColor={props.data.color} />)
}else if(props.data.mp3 !== null){
  return(
    <div className="audioPlayer">
    <h4>{props.data.title}</h4>
    <AudioPlayer
      src={props.data.mp3.publicURL}
      customAdditionalControls={[]}
      onPlay={e => typeof window !== "undefined" && window.gtag("event", "Podcast" ,{"event_category":"Play" ,"event_label":Location})}
      // other props here
    />
    <a rel="noreferrer" href={props.data.link} target="_blank">{props.data.teaser}</a>
    </div>)
}else if (props.data.DisplayType === "Squares_with_images" || props.data.DisplayType === "Squares_with_logo" || props.data.DisplayType === "Squares_with_large_icon" || props.data.DisplayType === "Squares_with_hover") {
      return (
  <div className="homesection" >
            <div className="column-group">
              <div className="all-100 push-left half-top-space">
                <h2 style={{ color: props.data.TitleColour }}>{props.data.Title}</h2>
              </div>
              <div className="all-100 push-left">
                <div className="column-group">
                  <div className="all-100 push-left" style={{ color: props.data.TextColour }}>
                    <div style={{ color: props.data.TextColour }}>
                      <ReactMarkdown source={props.data.text} linkTarget='_blank' escapeHtml={false} skipHtml={false} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="all-100 push-left">
                <SectionGrid data={props.data} style={props.data.DisplayType} position={props.data.Tile_text_pacement} />
              </div>
            </div>
                </div>

      )
}else if (props.data.DisplayType === "Squares_with_colours") {

      return (
                  <div className="homesection" >
            <div className="column-group">


              <div className="all-100 push-left half-top-space">
                <h2 style={{ color: props.data.TitleColour }}>{props.data.Title}</h2>
              </div>
              <div className="all-100 push-left">
                <div className="column-group">
                  <div className="all-100 push-left" style={{ color: props.data.TextColour }}>
                    <div style={{ color: props.data.TextColour }}>
                      <ReactMarkdown source={props.data.text} linkTarget='_blank' escapeHtml={false} skipHtml={false} />

                    </div>
                  </div>
                </div>
              </div>

              <div className="all-100 push-left">
                <SectionGrid data={props.data} style={props.data.DisplayType} position={props.data.Tile_text_pacement} />

              </div>
                </div>


            </div>

      )

    }else if (props.data.DisplayType === "Simple_buttons") {

      return (
            <div className="column-group">


              <div className="all-100 push-left half-top-space">
                <h2 style={{ color: props.data.TitleColour }}>{props.data.Title}</h2>
              </div>
              <div className="all-100 push-left ">
                <div className="column-group">
                  <div className="all-100 push-left" style={{ color: props.data.TextColour }}>
                    <div style={{ color: props.data.TextColour }}>
                      <ReactMarkdown source={props.data.text} linkTarget='_blank' escapeHtml={false} skipHtml={false} />

                    </div>
                  </div>
                </div>
              </div>

              <div className="all-100 push-left">

                <SectionGrid data={props.data} style="Simple_buttons" />
              </div>
            </div>


      )

    }else if (props.data.accordian_item !== null) {
      if (props.data.accordian_item.length > 0) {
        return (

              <div className="column-group">
                <div className="all-100 push-left half-top-space">
                  <h2 style={{ color: props.data.TitleColour }}>{props.data.Title}</h2>
                </div>
                <div className="all-100 push-left bottom-space">
                  <div className="column-group">
                    <div className="all-100 push-left" style={{ color: props.data.TextColour }}>
                      <div style={{ color: props.data.TextColour }}>
                        <ReactMarkdown source={props.data.text} linkTarget='_blank' escapeHtml={false} skipHtml={false} />

                      </div>
                    </div>
                  </div>
                </div>

                <div className="all-100 push-left bottom-space">

                  <AccordianSection data={props.data} />

                </div>

              </div>

        )
      }
    }else if (props.data.column_item !== null && props.data.column_item !== undefined) {
      if (props.data.column_item.length > 0) {

        return (

              <div className="column-group">
                <div className="all-100 push-left half-top-space">
                  <h2 style={{ color: props.data.TitleColour }}>{props.data.Title}</h2>
                </div>
                <div className="all-100 push-left  bottom-space">
                  <div className="column-group">
                    <div className="all-100 push-left" style={{ color: props.data.TextColour }}>
                      <div style={{ color: props.data.TextColour }}>
                        <ReactMarkdown source={props.data.text} linkTarget='_blank' escapeHtml={false} skipHtml={false} />

                      </div>
                    </div>
                  </div>
                </div>

                <div className="all-100 push-left bottom-space">

                  <ColumnSection data={props.data} />

                </div>

              </div>

        )

      }

    }else if (props.data.Type === "Large_text") {
      return (

            <div className="column-group gutters">
              <div className="all-100 top-space">
                <BackgroundImage Tag="div" className="kicker" fluid={returnImage(props.data.background,props.data.BackgroundColour,props.data.overlayOpacity)}>
                  <div className="column-group gutters">
                    <div className="xlarge-70 large-70 medium-100 small-100 tiny-100 top-space">
                      <h4 style={{ color: props.data.TitleColour }} >{props.data.Title}</h4>
                      <p style={{ color: props.data.TextColour }} >{props.data.text}</p>
                      <div className="actionLink" style={{ color: props.data.TitleColour }} >{props.data.buttontext}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path style={{fill: props.data.TitleColour }} d="M9 0C4 0 0 4 0 9s4 9 9 9v-1.7c-3.7 0-6.8-2.8-7.2-6.4h8.7l-2.7 2.6L9 13.7 13.8 9 9 4.3 7.8 5.5l2.6 2.6H1.8C2.2 4.5 5.3 1.7 9 1.7c4 0 7.3 3.3 7.3 7.3H18c0-5-4-9-9-9"/></svg></div>
                    </div>
                    <a className="kickerLink" href={props.data.link} target="_blank"></a>
                  </div>

                </BackgroundImage>

              </div>
            </div>



      )
}else if (props.data.Type === "Thin") {

      return (

            <div className="column-group gutters">
              <div className="all-100 top-space">
                <BackgroundImage Tag="div" className="kickerSmall" fluid={returnImage(props.data.background,props.data.BackgroundColour,props.data.overlayOpacity)}>
                  <div className="column-group gutters">
                    <div className="xlarge-50 large-50 medium-100 small-100 tiny-100 ">
                      <h4 style={{ color: props.data.TitleColour }} >{props.data.Title}</h4>
                      <p style={{ color: props.data.TextColour }}>{props.data.text}</p>
                    </div>
                    <div className="xlarge-15 large-15 medium-100 small-100 tiny-100 align-right push-right">
                          <div className="actionLink" style={{ color: props.data.TitleColour }} >{props.data.buttontext}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path style={{fill: props.data.TitleColour }} d="M9 0C4 0 0 4 0 9s4 9 9 9v-1.7c-3.7 0-6.8-2.8-7.2-6.4h8.7l-2.7 2.6L9 13.7 13.8 9 9 4.3 7.8 5.5l2.6 2.6H1.8C2.2 4.5 5.3 1.7 9 1.7c4 0 7.3 3.3 7.3 7.3H18c0-5-4-9-9-9"/></svg></div>
                    </div>
                    <a className="kickerLink" href={props.data.link} target="_blank"></a>
                  </div>
                </BackgroundImage>
              </div>


            </div>



      )




  }else{
    return(<></>)
  }

}

export default ArticleContent;
